import { render, staticRenderFns } from "./RecordsTable.vue?vue&type=template&id=50d60c4e&scoped=true&"
import script from "./RecordsTable.vue?vue&type=script&lang=js&"
export * from "./RecordsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d60c4e",
  null
  
)

export default component.exports